import React from 'react';
import { Field } from 'formik';

import styles from './cardFormStyles';

import CharacterLimit from 'buyside/components/presentation/CharacterLimit/CharacterLimit';
import ImageField from 'buyside/components/presentation/Form/Field/ImageField/imageField';
import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
import CityAutocomplete from 'buyside/components/presentation/CityAutocomplete/cityAutocomplete';

const {
  fundTypeNames,
  fundStrategyNames,
  fundFocuses
} = require('buyside/util/constantsFromRails.json');

// NOTE: make sure to update the appropriate schema in util/fundProfileShowPageValidationSchemata

const CardForm = ({ values: { fundProfile }, setFieldValue }) => {
  const { imageData, croppedImageData, logoUrl, logoProfileUrl, defaultLogo } = fundProfile;
  const logoNote = 'Optimal logo size is 250px by 250px.';
  const aumNote =
    'Your exact AUM will not be publicly visible. It will be expressed as an approximate range.';
  const descriptionLength = fundProfile.description && fundProfile.description.length;
  return (
    <div data-testid="fund-profile-form">
      <div className={styles.cardFormMainArea}>
        <div className={styles.cardFormColumn}>
          <Field
            component={ImageField}
            name="fundProfile"
            label="Logo"
            title="logo"
            image={imageData || logoUrl}
            croppedImage={croppedImageData || logoProfileUrl}
            defaultImage={defaultLogo}
            note={logoNote}
          />
          <Field
            component={InputField}
            name="fundProfile.aum"
            label="AUM"
            addon="million (USD)"
            note={aumNote}
          />
          <Field
            component={InputField}
            name="fundProfile.foundingDate"
            type="date"
            label="Founding Date"
          />
        </div>
        <div className={styles.cardFormColumn}>
          <Field
            component={InputField}
            name="fundProfile.fundType"
            type="select"
            label="Firm Type"
            options={fundTypeNames}
          />
          <Field
            component={InputField}
            name="fundProfile.strategy"
            type="select"
            label="Strategy"
            options={fundStrategyNames}
          />
          <Field
            component={InputField}
            name="fundProfile.focus"
            type="select"
            label="Focus"
            options={fundFocuses}
            required={false}
          />
          <CityAutocomplete
            name="fundProfile.location"
            setFieldValue={setFieldValue}
            label="Location"
          />
          <Field component={InputField} name="fundProfile.fundManager" label="Managed By" />
        </div>
      </div>
      <div className={styles.cardFormDescription}>
        <Field
          component={InputField}
          name="fundProfile.description"
          type="textarea"
          label="Description"
        />
        <CharacterLimit textLength={descriptionLength} limit={1250} />
      </div>
    </div>
  );
};

export default CardForm;
